import { SVGProps } from 'react'

export const TwitterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.7002 0C22.351 0.000105394 24.4999 2.14899 24.5 4.7998V19.2002C24.4999 21.851 22.351 23.9999 19.7002 24H5.2998C2.64899 23.9999 0.500105 21.851 0.5 19.2002V4.7998C0.500105 2.14899 2.64899 0.000105588 5.2998 0H19.7002ZM10.7305 12.8398L5 19.5H6.29492L11.3047 13.6758L15.3066 19.5H19.6777L13.7354 10.8516L19.1992 4.5H17.9043L13.1602 10.0146L9.37012 4.5H5L10.7305 12.8398ZM12.4785 10.8076L13.0586 11.6377L17.9053 18.5693H15.916L11.9619 12.9131L11.3809 12.083L6.76172 5.47461H8.75L12.4785 10.8076Z'
      fill='currentColor'
    />
  </svg>
)
